<template>
  <div class="block-ch">
    <div class="block-ch__content">
      <div class="block-ch__left">
        <div class="block-ch__image" data-aos="fade-up">
          <img src="../assets/img/ch-1.gif" alt="">
        </div>
        <div class="block-ch__title" data-aos="fade-up">
          Чарльстон
        </div>
        <div class="block-ch__poster" data-aos="fade-up"><img src="../assets/img/ch-poster.png" class="tilt" data-tilt-scale="1.2" alt=""></div>
      </div>
      <div class="block-ch__right">
        <div class="block-ch__letter letter letter-line-black" data-aos="fade-up">Ч.</div>
        <div class="block-ch__text" data-aos="fade-up">Один из самых провокативных аморальных танцев того времени получил своё название в честь города в штате Южная Каролина. Название шоу, которое дало первую волну популярности чарльстону, довольно точно описывает всю суть той эпохи «ревущих двадцатых» — шоу называлось «Runnin’ Wild», что можно перевести как «Распутный образ жизни» или «Одичав вконец». Изначально чарльстон сам по себе являлся формой презрения к так называемым «сухарям» — то есть приверженцам сухого закона.</div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'BlockF'
}
</script>

<style lang="sass">
  .block-ch
    color: #000
    padding-bottom: vw(20px)
    &__content
      display: flex
    &__image
      width: vw(430px)
      margin-left: vw(211px)
      margin-top: vw(103px)
      img
        width: 100%
    &__text
      width: vw(454px)
      margin-left: vw(111px)
      text-align: left
      font-family: 'Tautz'
      font-size: vw(16px)
      margin-top: vw(34px)
      letter-spacing: vw(-0.05px)
      line-height: vw(20px)
    &__title
      font-size: vw(72px)
      font-family: 'ZnikomitNo25'
      text-align: left
      margin-left: vw(310px)
      margin-top: vw(23px)
    &__letter
      margin-left: vw(116px)
      margin-top: vw(95px)
      padding-left: vw(22px)
      padding-top: vw(14px)
    &__poster
      width: vw(230px)
      margin-top: vw(-258px)
      margin-left: vw(40px)
      transform: rotate(-9.14deg) !important
      img
        width: 100%

</style>
